import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-594d5f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kam-kam004" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Projectnaam "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Projectnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Projectleider "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Uitvoerder "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Beoordelaar "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Datum beoordeling "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Scope / omschrijving", -1))
const _hoisted_9 = { class: "assessment-list" }
const _hoisted_10 = { class: "assessment-main" }
const _hoisted_11 = { class: "assessment-copy" }
const _hoisted_12 = { class: "assessment-score" }
const _hoisted_13 = { class: "assessment-fields" }
const _hoisted_14 = {
  key: 0,
  class: "required"
}
const _hoisted_15 = { class: "assessment-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Actie / maatregel", -1))
const _hoisted_17 = { class: "table-wrap" }
const _hoisted_18 = { class: "simple-table" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "action-description-column" }, "Actiepunt", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "action-owner-column" }, "Eigenaar", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "action-due-date-column" }, [
  /*#__PURE__*/_createTextVNode("Termijn "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "action-done-column" }, "Gereed", -1))
const _hoisted_23 = {
  key: 0,
  class: "action-remove-column"
}
const _hoisted_24 = { class: "action-description-column" }
const _hoisted_25 = { class: "action-owner-column" }
const _hoisted_26 = { class: "action-due-date-column" }
const _hoisted_27 = { class: "center-cell action-done-column" }
const _hoisted_28 = {
  key: 0,
  class: "center action-remove-column"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = {
  key: 0,
  class: "actions actions-left"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Eindoordeel "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Opvolging door", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Opvolgdatum", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Algemene toelichting", -1))
const _hoisted_36 = { class: "blocking-list" }
const _hoisted_37 = {
  key: 1,
  class: "actions"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je het formulier definitief wilt afronden?", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Aanpassingen zijn hierna niet meer mogelijk.", -1))

import { computed, ref, watch } from 'vue'
import type { ComputedRef } from 'vue'
import { DeleteOutlined } from '@ant-design/icons-vue'
import kamStore from '@/stores/kam.ts'
import { KAMFormStatuses } from '@/helpers/kamFormStates'
import {
  ensureArrayField,
  ensureObjectField,
  hasMeaningfulValue,
  mapPeopleToOptions,
  useConditionalRequiredFields,
  useDirtySnapshot
} from '@/helpers/kamFormUtils'
import type { PersonLikeOption, UnknownRecord } from '@/helpers/kamFormUtils'

type AssessmentKey = 'organization' | 'documents' | 'riskInventory' | 'instruction' | 'siteControl' | 'emergency' | 'incidents' | 'subcontractors'
type AssessmentScore = 'voldoende' | 'aandachtspunt' | 'onvoldoende' | 'nvt' | ''
type AssessmentRow = { score: AssessmentScore, finding: string, action: string }
type FinalJudgement = 'voldoende' | 'onvoldoende' | ''
type ActionRow = { description: string, owner: string, dueDate: string | null, done: boolean, assessmentKey?: AssessmentKey }
type KAM004Emits = {
  (e: 'changed'): void
  (e: 'dirty', value: boolean): void
  (e: 'required-filled', value: boolean): void
  (e: 'save-allowed', value: boolean): void
}
type Answers = UnknownRecord & {
  projectName?: string
  projectReference?: string
  projectLeaderId?: number | string | null
  siteManagerId?: number | string | null
  assessorId?: number | string | null
  assessorName?: string
  assessmentDate?: string
  scope?: string
  assessments: Record<AssessmentKey, AssessmentRow>
  actions?: ActionRow[]
  finalJudgement?: string
  followUpOwnerId?: number | string | null
  followUpOwner?: string
  followUpDate?: string
  finalNotes?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'KAM004-v1',
  props: {
    answers: null,
    editable: { type: Boolean },
    projectLeaders: null,
    siteManagers: null,
    constructionWorkers: null,
    qualityManagement: null
  },
  emits: ["changed", "dirty", "required-filled", "save-allowed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changed'): void
  (e: 'dirty', value: boolean): void
  (e: 'required-filled', value: boolean): void
  (e: 'save-allowed', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  answers: Record<string, unknown>
  editable: boolean
  projectLeaders: PersonLikeOption[]
  siteManagers: PersonLikeOption[]
  constructionWorkers?: PersonLikeOption[]
  qualityManagement?: PersonLikeOption[]
};

const assessmentItems: Array<{ key: AssessmentKey, title: string, description: string }> = [
  { key: 'organization', title: 'Organisatie en verantwoordelijkheden', description: 'Zijn VGM-rollen, taken en verantwoordelijkheden duidelijk belegd?' },
  { key: 'documents', title: 'VGM-plan en projectdocumentatie', description: 'Zijn VGM-plan, werkplannen en relevante projectdocumenten beschikbaar en actueel?' },
  { key: 'riskInventory', title: 'Risico-inventarisatie en beheersmaatregelen', description: 'Zijn projectspecifieke risico’s bekend en vertaald naar maatregelen?' },
  { key: 'instruction', title: 'Voorlichting en instructie', description: 'Zijn medewerkers en onderaannemers aantoonbaar voorgelicht en geinstrueerd?' },
  { key: 'siteControl', title: 'Bouwplaatsinrichting en toezicht', description: 'Worden bouwplaatsinrichting, orde/netheid, PBM en toezicht beheerst?' },
  { key: 'emergency', title: 'Noodorganisatie en middelen', description: 'Zijn BHV, EHBO, blusmiddelen en noodprocedures geregeld?' },
  { key: 'incidents', title: 'Incidenten en afwijkingen', description: 'Worden incidenten, bijna-ongevallen en gevaarlijke situaties gemeld en opgevolgd?' },
  { key: 'subcontractors', title: 'Onderaannemers en leveranciers', description: 'Is VGM-beheersing van onderaannemers en leveranciers geborgd?' }
]

const requiredFields = ['projectName', 'projectReference', 'projectLeaderId', 'siteManagerId', 'assessorId', 'assessmentDate', 'finalJudgement']
const requiredFieldLabels: Record<string, string> = {
  projectName: 'Projectnaam',
  projectReference: 'Projectnummer',
  projectLeaderId: 'Projectleider',
  siteManagerId: 'Uitvoerder',
  assessorId: 'Beoordelaar',
  assessmentDate: 'Datum beoordeling',
  finalJudgement: 'Eindoordeel'
}
const defaultAssessorName = 'Henk Tijssen'




const saving = ref(false)

const formAnswers = computed<Answers>(() => (kamStore().kamForm?.answers ?? props.answers ?? {}) as Answers)
const projectLeaderOptions = computed(() => mapPeopleToOptions(props.projectLeaders))
const siteManagerOptions = computed(() => mapPeopleToOptions(props.siteManagers))
const constructionWorkerOptions = computed(() => mapPeopleToOptions(props.constructionWorkers || []))
const qualityManagementOptions = computed(() => mapPeopleToOptions(props.qualityManagement || []))
const actionRows = computed(() => ensureArrayField<ActionRow>(formAnswers.value, 'actions'))
const actionOwnerOptions = computed(() => {
  const options: Array<{ label: string, value: string }> = []
  const seen = new Set<string>()

  function addOption (label: string): void {
    const normalized = label.trim()
    if (!normalized || seen.has(normalized)) return
    seen.add(normalized)
    options.push({ label: normalized, value: normalized })
  }

  addOption(siteManagerLabel())
  constructionWorkerOptions.value.forEach(option => addOption(option.label))
  actionRows.value.forEach(row => addOption(row.owner || ''))

  return options
})
const actionDatesValid = computed(() => actionRows.value.every(row => isValidActionDueDate(row.dueDate)))
const followUpOwnerManuallyChanged = ref(false)
const previousSuggestedFinalJudgement = ref<FinalJudgement>('')

const { capture } = useDirtySnapshot(formAnswers as ComputedRef<UnknownRecord>, value => emit('dirty', value))
const closeBlockingMessages = computed(() => {
  const messages: string[] = []
  const answers = formAnswers.value as UnknownRecord
  const assessments = ensureAssessments(formAnswers.value)

  requiredFields.forEach(field => {
    if (!hasMeaningfulValue(answers, field)) messages.push(`${requiredFieldLabels[field]} invullen`)
  })

  assessmentItems.forEach(item => {
    const assessment = assessments[item.key] as UnknownRecord
    if (!hasMeaningfulValue(assessment, 'score')) {
      messages.push(`VGM-beheersing: score kiezen bij ${item.title}`)
      return
    }

    if (isAttentionPoint(item.key) && !hasMeaningfulValue(assessment, 'finding')) {
      messages.push(`VGM-beheersing: toelichting invullen bij aandachtspunt ${item.title}`)
    }
  })

  actionRows.value.forEach((row, index) => {
    const actionLabel = actionRowLabel(row, index)
    if (!isValidActionDueDate(row.dueDate)) messages.push(`${actionLabel}: termijn invullen`)
  })

  return messages
})
const formComplete = useConditionalRequiredFields(() => {
  return closeBlockingMessages.value.length === 0
}, value => emit('required-filled', value))
const targetStatus = computed(() => {
  if (!formComplete.value) return KAMFormStatuses.Concept
  return KAMFormStatuses.Reported
})

watch(actionDatesValid, value => emit('save-allowed', value), { immediate: true })

function ensureAssessments (answers: Answers): Record<AssessmentKey, AssessmentRow> {
  const assessments = ensureObjectField<UnknownRecord>(answers, 'assessments') as Record<AssessmentKey, Partial<AssessmentRow>>
  assessmentItems.forEach(item => {
    const current = assessments[item.key] || {}
    assessments[item.key] = {
      score: (current.score || '') as AssessmentScore,
      finding: current.finding || '',
      action: current.action || ''
    }
  })
  return assessments as Record<AssessmentKey, AssessmentRow>
}

function initializeAnswers (): void {
  const answers = formAnswers.value
  ensureAssessments(answers)
  ensureArrayField<ActionRow>(answers, 'actions').forEach(row => {
    if (!row.owner) row.owner = defaultActionOwner()
    row.dueDate = normalizeDatePickerValue(row.dueDate)
    row.done = Boolean(row.done)
  })
  if (!answers.assessmentDate) answers.assessmentDate = today()
  answers.assessmentDate = normalizeDatePickerValue(answers.assessmentDate) || today()
  if (!answers.assessorId) {
    const defaultAssessor = findQualityManagerByName(defaultAssessorName)
    if (defaultAssessor) {
      answers.assessorId = defaultAssessor.id
      answers.assessorName = defaultAssessor.label
    }
  }
  answers.followUpDate = normalizeDatePickerValue(answers.followUpDate)
  if (!answers.followUpOwnerId && answers.assessorId) {
    answers.followUpOwnerId = answers.assessorId
    answers.followUpOwner = personName(answers.assessorId)
  }
  const assessorName = personName(answers.assessorId)
  const followUpOwnerName = personName(answers.followUpOwnerId)
  answers.assessorName = assessorName || (answers.assessorId ? answers.assessorName || '' : '')
  answers.followUpOwner = followUpOwnerName || (answers.followUpOwnerId ? answers.followUpOwner || '' : '')
  followUpOwnerManuallyChanged.value = Boolean(
    answers.followUpOwnerId &&
    String(answers.followUpOwnerId) !== String(answers.assessorId ?? '')
  )
  syncFinalJudgementWithAssessments()
}

function findQualityManagerByName (name: string): { id: string | number, label: string } | undefined {
  const normalizedName = name.trim().toLocaleLowerCase('nl-NL')
  return qualityManagementOptions.value.find(person => person.label.trim().toLocaleLowerCase('nl-NL') === normalizedName)
}

function isAttentionPoint (key: AssessmentKey): boolean {
  return formAnswers.value.assessments[key]?.score === 'aandachtspunt'
}

function attentionFindingMissing (key: AssessmentKey): boolean {
  return isAttentionPoint(key) && !hasMeaningfulValue(formAnswers.value.assessments[key] as UnknownRecord, 'finding')
}

function actionRowLabel (row: ActionRow, index: number): string {
  const description = row.description?.trim()
  return description ? `Actiepunt ${index + 1} (${description})` : `Actiepunt ${index + 1}`
}

function personName (id: string | number | null | undefined): string {
  if (id === null || typeof id === 'undefined' || id === '') return ''
  return qualityManagementOptions.value.find(person => String(person.id) === String(id))?.label || ''
}

function handleAssessorChange (value: string | number | undefined): void {
  const next = value ?? null

  formAnswers.value.assessorId = next
  formAnswers.value.assessorName = personName(next)

  if (!followUpOwnerManuallyChanged.value) {
    formAnswers.value.followUpOwnerId = next
    formAnswers.value.followUpOwner = personName(next)
  }

  emit('dirty', true)
}

function handleFollowUpOwnerChange (value: string | number | undefined): void {
  const next = value ?? null
  formAnswers.value.followUpOwnerId = next
  formAnswers.value.followUpOwner = personName(next)
  followUpOwnerManuallyChanged.value = true
  emit('dirty', true)
}

function addAction (): void {
  actionRows.value.push({ description: '', owner: defaultActionOwner(), dueDate: null, done: false })
  emit('dirty', true)
}

function handleScoreChange (key: AssessmentKey): void {
  syncFinalJudgementWithAssessments()
  const assessment = formAnswers.value.assessments[key]
  if (!assessment || assessment.score !== 'onvoldoende') {
    emit('dirty', true)
    return
  }

  const existing = actionRows.value.some(row => row.assessmentKey === key)
  if (!existing) {
    const item = assessmentItems.find(item => item.key === key)
    actionRows.value.push({
      description: `Actie n.a.v. onvoldoende: ${item?.title || key}`,
      owner: defaultActionOwner(),
      dueDate: null,
      done: false,
      assessmentKey: key
    })
  }

  emit('dirty', true)
}

function removeAction (index: number): void {
  actionRows.value.splice(index, 1)
  emit('dirty', true)
}

function today (): string {
  return new Date().toISOString().slice(0, 10)
}

function normalizeDatePickerValue (value: unknown): string | null {
  if (value === null || typeof value === 'undefined' || value === '') return null
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value.toISOString().slice(0, 10)

  const rawValue = String(value)
  const isoMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoMatch) return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`

  const nlMatch = rawValue.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/)
  if (nlMatch) {
    const [, day, month, year] = nlMatch
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  return null
}

function isValidActionDueDate (value: unknown): boolean {
  const normalized = normalizeDatePickerValue(value)
  if (!normalized) return false

  const [year, month, day] = normalized.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))

  return date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
}

function siteManagerLabel (): string {
  const selectedId = formAnswers.value.siteManagerId
  if (selectedId === null || typeof selectedId === 'undefined' || selectedId === '') return ''
  const selected = siteManagerOptions.value.find(option => String(option.id) === String(selectedId))
  return selected?.label || ''
}

function defaultActionOwner (): string {
  return siteManagerLabel()
}

function suggestedFinalJudgement (): FinalJudgement {
  const scores = assessmentItems.map(item => formAnswers.value.assessments[item.key]?.score || '')
  if (scores.some(score => score === 'onvoldoende')) return 'onvoldoende'
  if (scores.some(score => score === 'aandachtspunt')) return 'voldoende'
  if (scores.every(score => score === 'voldoende' || score === 'nvt')) return 'voldoende'
  return ''
}

function syncFinalJudgementWithAssessments (): void {
  const nextSuggestion = suggestedFinalJudgement()
  const currentJudgement = (formAnswers.value.finalJudgement || '') as FinalJudgement

  if (!nextSuggestion) {
    if (currentJudgement && currentJudgement === previousSuggestedFinalJudgement.value) {
      formAnswers.value.finalJudgement = ''
    }
    previousSuggestedFinalJudgement.value = ''
    return
  }

  if (nextSuggestion && (!currentJudgement || currentJudgement === previousSuggestedFinalJudgement.value)) {
    formAnswers.value.finalJudgement = nextSuggestion
  }

  previousSuggestedFinalJudgement.value = nextSuggestion
}

async function saveForm (): Promise<void> {
  if (!kamStore().kamForm || !actionDatesValid.value) return
  saving.value = true
  try {
    await kamStore().saveForm(kamStore().kamForm.id, formAnswers.value as Record<string, unknown>, targetStatus.value)
    if (kamStore().kamForm) kamStore().kamForm.status = targetStatus.value
    capture()
    emit('changed')
  } finally {
    saving.value = false
  }
}

async function finalizeForm (): Promise<void> {
  if (!kamStore().kamForm || !formComplete.value || !actionDatesValid.value) return
  saving.value = true
  try {
    await kamStore().saveForm(kamStore().kamForm.id, formAnswers.value as Record<string, unknown>, KAMFormStatuses.Closed)
    if (kamStore().kamForm) kamStore().kamForm.status = KAMFormStatuses.Closed
    capture()
    emit('changed')
  } finally {
    saving.value = false
  }
}

watch(() => kamStore().kamForm, () => {
  initializeAnswers()
  capture()
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      class: "mt16",
      loading: saving.value,
      title: "Beoordeling VGM-beheersing Projecten (V1)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          size: "small",
          title: "Project- en beoordelingscontext"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: [16, 12] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_a_input, {
                      value: _unref(formAnswers).projectName,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formAnswers).projectName) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Projectnaam"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createVNode(_component_a_input, {
                      value: _unref(formAnswers).projectReference,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formAnswers).projectReference) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Projectnummer"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_a_select, {
                      value: _unref(formAnswers).projectLeaderId,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formAnswers).projectLeaderId) = $event)),
                      disabled: !__props.editable,
                      options: _unref(projectLeaderOptions),
                      "field-names": { label: 'label', value: 'id' },
                      "show-search": "",
                      "option-filter-prop": "label",
                      placeholder: "Selecteer projectleider"
                    }, null, 8, ["value", "disabled", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createVNode(_component_a_select, {
                      value: _unref(formAnswers).siteManagerId,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formAnswers).siteManagerId) = $event)),
                      disabled: !__props.editable,
                      options: _unref(siteManagerOptions),
                      "field-names": { label: 'label', value: 'id' },
                      "show-search": "",
                      "option-filter-prop": "label",
                      placeholder: "Selecteer uitvoerder"
                    }, null, 8, ["value", "disabled", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    (__props.editable)
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          value: _unref(formAnswers).assessorId,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formAnswers).assessorId) = $event)),
                          options: _unref(qualityManagementOptions),
                          "field-names": { label: 'label', value: 'id' },
                          "show-search": "",
                          "option-filter-prop": "label",
                          "allow-clear": "",
                          placeholder: "Selecteer beoordelaar",
                          onChange: handleAssessorChange
                        }, null, 8, ["value", "options"]))
                      : (_openBlock(), _createBlock(_component_a_input, {
                          key: 1,
                          value: _unref(formAnswers).assessorName,
                          disabled: ""
                        }, null, 8, ["value"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_a_date_picker, {
                      value: _unref(formAnswers).assessmentDate,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formAnswers).assessmentDate) = $event)),
                      disabled: !__props.editable,
                      format: "DD-MM-YYYY",
                      "value-format": "YYYY-MM-DD",
                      style: {"width":"100%"}
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).scope,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formAnswers).scope) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Omschrijving van projectfase, werkzaamheden of scope van de beoordeling",
                      "auto-size": { minRows: 2 }
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "VGM-beheersing"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(assessmentItems, (item) => {
                return _createElementVNode("div", {
                  class: "assessment-item",
                  key: item.key
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                      _createElementVNode("p", null, _toDisplayString(item.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_radio_group, {
                        class: "score-group",
                        value: _unref(formAnswers).assessments[item.key].score,
                        "onUpdate:value": ($event: any) => ((_unref(formAnswers).assessments[item.key].score) = $event),
                        disabled: !__props.editable,
                        "button-style": "solid",
                        onChange: ($event: any) => (handleScoreChange(item.key))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio_button, {
                            class: "score-option score-good",
                            value: "voldoende"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Voldoende")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio_button, {
                            class: "score-option score-attention",
                            value: "aandachtspunt"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Aandachtspunt")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio_button, {
                            class: "score-option score-bad",
                            value: "onvoldoende"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Onvoldoende")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio_button, {
                            class: "score-option score-na",
                            value: "nvt"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("N.v.t.")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value", "disabled", "onChange"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["assessment-field", { 'attention-required': attentionFindingMissing(item.key) }])
                    }, [
                      _createElementVNode("label", null, [
                        _createTextVNode("Bevinding / toelichting "),
                        (isAttentionPoint(item.key))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_a_textarea, {
                        value: _unref(formAnswers).assessments[item.key].finding,
                        "onUpdate:value": ($event: any) => ((_unref(formAnswers).assessments[item.key].finding) = $event),
                        disabled: !__props.editable,
                        placeholder: "Beschrijf de bevinding",
                        "auto-size": { minRows: 3 }
                      }, null, 8, ["value", "onUpdate:value", "disabled"])
                    ], 2),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_a_textarea, {
                        value: _unref(formAnswers).assessments[item.key].action,
                        "onUpdate:value": ($event: any) => ((_unref(formAnswers).assessments[item.key].action) = $event),
                        disabled: !__props.editable,
                        placeholder: "Beschrijf actie of maatregel",
                        "auto-size": { minRows: 3 }
                      }, null, 8, ["value", "onUpdate:value", "disabled"])
                    ])
                  ])
                ])
              }), 64))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Actiepunten"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("table", _hoisted_18, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    (__props.editable)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_23))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(actionRows), (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_24, [
                        _createVNode(_component_a_textarea, {
                          value: row.description,
                          "onUpdate:value": ($event: any) => ((row.description) = $event),
                          disabled: !__props.editable,
                          placeholder: "Omschrijving",
                          "auto-size": { minRows: 1 }
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(_component_a_select, {
                          value: row.owner,
                          "onUpdate:value": ($event: any) => ((row.owner) = $event),
                          disabled: !__props.editable,
                          options: _unref(actionOwnerOptions),
                          "show-search": "",
                          "option-filter-prop": "label",
                          placeholder: "Selecteer eigenaar",
                          style: {"width":"100%"}
                        }, null, 8, ["value", "onUpdate:value", "disabled", "options"])
                      ]),
                      _createElementVNode("td", _hoisted_26, [
                        _createVNode(_component_a_date_picker, {
                          value: row.dueDate,
                          "onUpdate:value": ($event: any) => ((row.dueDate) = $event),
                          disabled: !__props.editable,
                          format: "DD-MM-YYYY",
                          "value-format": "YYYY-MM-DD",
                          placeholder: "Selecteer datum",
                          style: {"width":"100%"}
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _createElementVNode("td", _hoisted_27, [
                        _createVNode(_component_a_checkbox, {
                          checked: row.done,
                          "onUpdate:checked": ($event: any) => ((row.done) = $event),
                          disabled: !__props.editable
                        }, null, 8, ["checked", "onUpdate:checked", "disabled"])
                      ]),
                      (__props.editable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                            _createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              title: "Rij verwijderen",
                              onClick: ($event: any) => (removeAction(index))
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(DeleteOutlined))
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (!_unref(actionRows).length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                        _createElementVNode("td", {
                          colspan: __props.editable ? 5 : 4
                        }, "Geen actiepunten toegevoegd.", 8, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (__props.editable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(_component_a_button, { onClick: addAction }, {
                    default: _withCtx(() => [
                      _createTextVNode("Actiepunt toevoegen")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_card, {
          size: "small",
          class: "mt16",
          title: "Afronding"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: [16, 12] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createVNode(_component_a_select, {
                      value: _unref(formAnswers).finalJudgement,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formAnswers).finalJudgement) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Selecteer eindoordeel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "voldoende" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Voldoende")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "onvoldoende" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Onvoldoende")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _hoisted_33,
                    (__props.editable)
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          value: _unref(formAnswers).followUpOwnerId,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formAnswers).followUpOwnerId) = $event)),
                          options: _unref(qualityManagementOptions),
                          "field-names": { label: 'label', value: 'id' },
                          "show-search": "",
                          "option-filter-prop": "label",
                          "allow-clear": "",
                          placeholder: "Selecteer KAM-manager",
                          onChange: handleFollowUpOwnerChange
                        }, null, 8, ["value", "options"]))
                      : (_openBlock(), _createBlock(_component_a_input, {
                          key: 1,
                          value: _unref(formAnswers).followUpOwner,
                          disabled: ""
                        }, null, 8, ["value"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _createVNode(_component_a_date_picker, {
                      value: _unref(formAnswers).followUpDate,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formAnswers).followUpDate) = $event)),
                      disabled: !__props.editable,
                      format: "DD-MM-YYYY",
                      "value-format": "YYYY-MM-DD",
                      style: {"width":"100%"}
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).finalNotes,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formAnswers).finalNotes) = $event)),
                      disabled: !__props.editable,
                      placeholder: "Algemene toelichting of samenvatting",
                      "auto-size": { minRows: 3 }
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.editable && _unref(closeBlockingMessages).length)
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 0,
              class: "mt16",
              type: "warning",
              "show-icon": "",
              message: "Nog nodig om het formulier volledig te maken"
            }, {
              description: _withCtx(() => [
                _createElementVNode("ul", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(closeBlockingMessages), (message) => {
                    return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.editable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createVNode(_component_a_button, {
                disabled: saving.value || !_unref(actionDatesValid),
                onClick: saveForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Opslaan")
                ]),
                _: 1
              }, 8, ["disabled"]),
              (_unref(formComplete) && _unref(actionDatesValid) && !saving.value)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    placement: "topRight",
                    "ok-text": "Ja, definitief afronden",
                    "cancel-text": "Nee",
                    onConfirm: finalizeForm
                  }, {
                    title: _withCtx(() => [
                      _hoisted_38,
                      _hoisted_39
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Definitief afronden")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Definitief afronden")
                    ]),
                    _: 1
                  }))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})